import { render, staticRenderFns } from "./VcidEditForm.vue?vue&type=template&id=66b6f018"
import script from "./VcidEditForm.vue?vue&type=script&lang=js"
export * from "./VcidEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports